export enum ProductSectionView {
  ATTRIBUTION = "attribution",
  LIST_PRODUCT = "product",
  LIST_SKU = "sku",
  LIST_SIZING = "sizing",
  GRID = "grid",
}
